/**
 * Prefer API `firstVideoDocId`; else `watchedVideos` as array of ids;
 * else legacy map `{ videoId: boolean }` keys.
 */
export function pickFirstVideoDocId(serie: any): string | undefined {
    if (!serie) return undefined;
    if (serie.firstVideoDocId) return serie.firstVideoDocId;
    const w = serie.watchedVideos;
    if (Array.isArray(w) && w.length > 0 && typeof w[0] === "string") {
        return w[0];
    }
    if (w && typeof w === "object" && !Array.isArray(w)) {
        const keys = Object.keys(w);
        if (keys.length > 0) return keys[0];
    }
    return undefined;
}
